import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Check } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';
import { Counter, ChipVariants } from '@lichtblick/types';

import { CheckboxContainer, HiddenCheckbox, StyledCheckbox } from './Checkbox.styles';

import { Chip } from '../Chip';
import { Text } from '../Text';

export type CheckboxProps = {
  counter?: Counter;
  isChecked?: boolean;
  label?: string;
  onChange?: (id?: string) => void;
  setChecked?: Dispatch<SetStateAction<boolean>>;
  variant?: ChipVariants | 'default';
};

export const Checkbox = ({
  counter = { count: 0, link: '' },
  isChecked = false,
  label,
  onChange,
  setChecked,
  variant = 'default',
}: CheckboxProps) => {
  const [isCheckedInternal, setIsCheckedInternal] = useState(isChecked);

  useEffect(() => {
    setIsCheckedInternal(isChecked);
  }, [isChecked]);

  const isCheckedValue = setChecked || onChange ? isChecked : isCheckedInternal;

  const handleToggle = () => {
    if (onChange) {
      onChange();

      return;
    }

    if (setChecked) {
      setChecked(!isChecked);

      return;
    }

    setIsCheckedInternal((current) => !current);
  };

  return (
    <CheckboxContainer as="label">
      <HiddenCheckbox checked={isCheckedValue} onChange={handleToggle} type="checkbox" />
      <StyledCheckbox $isChecked={isCheckedValue}>{isCheckedValue && <Check />}</StyledCheckbox>
      {variant == 'default' ? (
        <Text $variant={TextVariants.body.m}>{label}</Text>
      ) : (
        <Chip counter={counter} size="small" text={label} variant={variant}></Chip>
      )}
    </CheckboxContainer>
  );
};
